export const getAddressList = (state) => state.map.addressList;